module.exports = __webpack_public_path__ + "img/reading5.d063df20.png";